<template>
  <f7-page
    no-toolbar
    no-navbar
    no-swipeback
    @page:reinit="loadPersons"
  >
    <div
      v-if="userMenu"
      class="fixed right-0 mt-20 mr-5 bg-white p-6 shadow-xl rounded-lg"
    >
      <a
        class="flex items-center"
        @click="askForLogout"
      >
        <eva-icon
          name="power-outline"
          fill="#FF7570"
          width="32"
          height="32"
        />
        <span class="ml-2">Cerrar sesión</span>
      </a>
    </div>
    <div v-if="loadedPersons && Object.keys(persons).length !== 0">
      <button
        v-if="!alreadyReportedToday[selectedPersonID]"
        class="fixed right-0 bottom-0 mr-5 disabled:opacity-50 block w-40 h-12 leading-12 bg-purple-500 text-white text-center text-xl rounded-md"
        :disabled="!canSubmit"
        @click.prevent="submitAnswers"
      >
        Confirmar
      </button>
      <div class="mx-10 mb-32 select-none">
        <a
          v-if="account.accessPoint && !isAdmin"
          class="absolute left-0 top-0 m-5 rounded-full shadow-lg p-2 leading-3 bg-purple-500"
          href="/access-point/"
        >
          <eva-icon
            name="video-outline"
            fill="#FFFFFF"
            width="32"
            height="32"
          />
        </a>
        <a
          v-if="!isAdmin"
          class="fixed right-0 top-0 m-5 rounded-full shadow-lg p-2 leading-3 z-50"
          @click="userMenu = !userMenu"
        >
          <eva-icon
            :name="!userMenu? 'menu-outline' : 'close-outline'"
            fill="#6C63FF"
            width="32"
            height="32"
          />
        </a>
        <div>
          <div class="flex flex-col-reverse mt-4 mb-2 max-w-lg mx-auto">
            <div
              class="relative flex flex-wrap mx-auto justify-between w-10/12"
            >
              <div class="absolute w-full border-b-2 border-dashed border-gray-300 h-6 z-0" />
              <div
                v-for="(person, personID) of persons"
                :key="personID"
                :class="`z-50 w-12 h-12 rounded-full shadow-lg p-2 pb-2 text-base text-center border border-gray-300 cursor-pointer ${getSelectionClass(personID)}`"
                @click="handleSelect(personID)"
              >
                <eva-icon
                  v-if="alreadyReportedToday[personID]"
                  name="checkmark-outline"
                  fill="#FFFFFF"
                  width="24"
                  height="24"
                  class="align-text-bottom"
                />
                <div
                  v-else
                  class="text-center text-white leading-5 font-bold"
                >
                  -
                </div>
              </div>
            </div>
            <img
              v-if="!!selectedPersonID && instance"
              class="w-20 mb-4"
              :src="instance.logoUrl"
              alt="logo"
            >
          </div>
          <div
            v-if="!!selectedPersonID"
          >
            <transition
              name="slide-fade"
              mode="out-in"
            >
              <div
                v-if="persons[selectedPersonID]"
                :key="selectedPersonID"
                ref="personLabelName"
                class="text-xl text-purple-500 font-bold text-center max-w-lg mx-auto rounded-sm p-2 break-all sticky top-0 bg-white z-50"
              >
                {{ persons[selectedPersonID].name }}
              </div>
            </transition>
            <div
              v-if="!alreadyReportedToday[selectedPersonID]"
              class="max-w-lg mx-auto"
            >
              <div
                v-for="categoryID in categoryIDs"
                :key="categoryID"
                class="mb-10 bg-bluegray-500 rounded-md pb-2"
              >
                <div
                  class="max-w- m-auto text-lg font-bold text-white bg-purple-500 text-center py-2 rounded-tl-md rounded-tr-md sticky top-16 z-40"
                >
                  {{ categories[categoryID].name }}
                </div>
                <div
                  :id="`${categoryID}-header`"
                  :ref="categoryID"
                  class="max-w- m-auto h-1 text-lg font-bold text-white bg-purple-500 text-center py-2 rounded-tl-md rounded-tr-md sticky -top-1 z-40 invisible"
                />
                <label
                  v-for="fieldID in categories[categoryID].fieldIDs"
                  :key="fieldID"
                  class="custom-label flex my-2 cursor-pointer border py-4 px-2 rounded-lg bg-white mx-2"
                >
                  <div
                    :class="`flex-shrink-0 ${getBackground(categoryID, fieldID)} rounded-lg w-12 h-12 p-1 flex justify-center items-center`"
                  >
                    <input
                      type="checkbox"
                      class="hidden"
                      :value="`${categoryID}_${fieldID}`"
                      :checked="answers[categoryID] ? answers[categoryID][fieldID] : false"
                      @change="handleInput($event, categoryID, fieldID)"
                    >
                    <svg
                      :class="`opacity-25 w-6 h-6 pointer-events-none`"
                      viewBox="0 0 172 172"
                    ><g
                      fill="none"
                      stroke-width="none"
                      stroke-miterlimit="10"
                      font-family="none"
                      font-weight="none"
                      font-size="none"
                      text-anchor="none"
                      style="mix-blend-mode:normal"
                    ><path d="M0 172V0h172v172z" /><path
                      d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z"
                      :fill="`${answers[categoryID] ? (answers[categoryID][fieldID] ? 'white' : 'gray') : 'gray'}`"
                      stroke-width="2"
                    /></g></svg>
                  </div>
                  <span class="self-center text-base select-none ml-8 w-full">
                    {{ categories[categoryID].fields[fieldID].label }}
                  </span>
                </label>
                <div
                  :id="`${categoryID}-footer`"
                  :ref="categoryID"
                  class="max-w- m-auto h-1 text-lg font-bold text-white bg-purple-500 text-center py-2 rounded-tl-md rounded-tr-md sticky bottom-1 z-40 invisible"
                />
              </div>
            </div>
            <div v-else>
              <div>
                <img
                  class="w-64 mx-auto mt-10 mb-4"
                  src="@/assets/celebration.svg"
                  alt="celebration"
                >
                <div class="text-center text-lg max-w-lg mx-auto">
                  <span class="text-purple-500 font-bold">{{ instance.name }}</span> agradece tu compromiso reportando, recuerda que al <span class="text-purple-500 font-bold">Cuidarte</span>, ¡nos cuidas a todos!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="m-8 p-4 text-lg bg-bluegray-500 rounded-sm"
    >
      Parece que no tienes personas asignadas o estan deshabilitadas, por favor contacta a un administrador de la institucion si consideras que esto es un error.
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex'
import * as axios from 'axios'
import moment from 'moment-timezone'
import { db, firebaseTools } from '../utils/firebase'

export default {
  components: {
  },
  props: {
    campaignID: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      loadedPersons: false,
      selectedPersonID: null,
      date: null,
      answers: {},
      userMenu: false,
      testCheck: false,
      rules: {},
      rulesBinds: {},
      ctx: null,
      stuckElementID: null,
      campaign: {},
    }
  },
  computed: {
    categories () {
      console.info('campaign', this.campaign)
      if (!this.campaign.form) return {}
      return this.campaign.form.categories
    },
    categoryIDs () {
      console.info('campaign', this.campaign)
      if (!this.campaign.form) return []
      return this.campaign.form.categoryIDs
    },
    isDoneReporting () {
      return Object.keys(this.alreadyReportedToday).length === Object.keys(this.persons).length
    },
    instanceID () {
      if (this.persons[this.selectedPersonID]) {
        return this.persons[this.selectedPersonID].instanceID
      }
      return null
    },
    canSubmit () {
      let allowed = true
      for (const categoryID of this.categoryIDs) {
        if (this.categories[categoryID].mandatory) {
          if (!this.answers[categoryID] || !Object.keys(this.answers[categoryID]).length) {
            allowed = false
          }
        }
      }
      return allowed
    },
    alreadyReportedToday () {
      const reportedToday = {}
      for (const personID in this.persons) {
        if (this.campaign && this.campaign.metrics && this.campaign.metrics.answeredBy && this.campaign.metrics.answeredBy.indexOf(personID) !== -1) {
          this.$set(reportedToday, personID, true)
          console.info('reported', this.$set(reportedToday, personID, true))
        }
      }
      return reportedToday
    },
    instance () {
      return this.instancesInfo[this.instanceID]
    },
    ...mapState({
      account: state => state.auth.account,
      uid: state => state.auth.uid,
      instancesInfo: state => state.auth.instancesInfo,
      persons: state => state.access.persons,
      isAdmin: state => state.auth.isAdmin,
    }),
  },
  watch: {
  },
  mounted () {
    moment.locale('es')
    this.date = moment().tz('America/Bogota').format('DD MMMM YYYY')
    this.loadPersons()
    db.collection('campaigns').doc(this.campaignID).onSnapshot(snapshot => {
      if (snapshot.exists) {
        this.campaign = snapshot.data()
        this.nextPerson()
      }
    })
    setTimeout(() => {
      this.stuckElementID = this.categoryIDs[0]
      for (const categoryID of this.categoryIDs) {
        const stickyElm = this.$refs[categoryID][0]
        const stickyElm2 = this.$refs[categoryID][1]
        const observer = new IntersectionObserver(
          ([e]) => {
            let condition = false
            let type = ''
            if (e.target.id.split('-').length > 1) {
              type = e.target.id.split('-')[1]
              if (type === 'footer') {
                condition = e.intersectionRatio === 1 && e.intersectionRatio > 0
              } else {
                condition = e.intersectionRatio < 1 && e.intersectionRatio > 0
              }
            }
            if (condition) {
              this.stuckElementID = e.target.id.split('-')[0]
            }
          },
          { threshold: [1] }
        )
        observer.observe(stickyElm)
        observer.observe(stickyElm2)
      }
    }, 1000)
  },
  beforeDestroy () {
    if (Object.keys(this.rulesBinds) > 0) {
      for (const bind of Object.values(this.rulesBinds)) {
        bind()
      }
    }
  },
  methods: {
    loadPersons () {
      this.$store.commit('access/resetPersons')
      if (this.account.access) {
        const instances = Object.keys(this.account.access)
        let remainingInstances = instances.length
        for (const instanceID of instances) {
          remainingInstances--
          let remainingPersons = this.account.access[instanceID].length
          for (const personID of this.account.access[instanceID]) {
            db.collection('instances').doc(instanceID).collection('persons').doc(personID).onSnapshot(personDoc => {
              if (personDoc.exists && personDoc.data().active !== false) {
                this.$store.commit('access/setPerson', { ID: personID, data: personDoc.data(), instanceID })
                this.$set(this.rules, personID, {})
                if (typeof this.rulesBinds[personID] === 'undefined') {
                  this.rulesBind = db.collection('instances').doc(instanceID).collection('rules').onSnapshot(snap => {
                    if (!snap.empty) {
                      snap.docChanges().forEach(change => {
                        if (change.type === 'added' || change.type === 'modified') {
                          this.$set(this.rules[personID], change.doc.id, {
                            id: change.doc.id,
                            ...change.doc.data(),
                          })
                        } else {
                          this.$delete(this.rules, change.doc.id)
                        }
                      })
                    }
                  }, (err) => { console.info(err.code) })
                }
                this.nextPerson()
              }
              if (remainingPersons > 0) remainingPersons--
              if (remainingInstances === 0 && remainingPersons === 0) {
                this.loadedPersons = true
              }
            })
          }
        }
      }
    },
    fulfillsTagConditions (categoryID, personID) {
      if (!this.categories[categoryID].byTags) {
        return true
      }
      if (!this.categories[categoryID].tagIDs || !this.persons[this.selectedPersonID].tagIDs) {
        return false
      }
      const categoryTagIDs = Object.keys(this.categories[categoryID].tagIDs)
      const personTagIDs = Object.keys(this.persons[this.selectedPersonID].tagIDs)
      let fulfills = false
      for (const categoryTagID of categoryTagIDs) {
        if (personTagIDs.includes(categoryTagID)) {
          fulfills = true
        }
      }
      return fulfills
    },
    askForLogout () {
      this.$f7.dialog.confirm('La próxima vez que abras la app deberás volver a entrar tu numero de celular.', '¿Estas seguro?', async () => {
        try {
          this.$f7.dialog.preloader('Eliminando datos locales...')
          await firebaseTools.signOut()
        } catch (err) {
          this.$f7.preloader.hide()
          console.error(err)
        }
      })
    },
    getSelectionClass (personID) {
      if (this.alreadyReportedToday[personID]) {
        if (personID === this.selectedPersonID) {
          return 'bg-green-500 text-white w-10 h-10 leading-8'
        } else {
          return 'bg-green-500 text-white'
        }
      }
      if (personID === this.selectedPersonID) {
        return 'bg-purple-500 text-white w-10 h-10 leading-8'
      }
      return 'hover:bg-purple-200 bg-white'
    },
    getBackground (categoryID, fieldID) {
      if (this.answers[categoryID] && this.answers[categoryID][fieldID]) {
        return 'bg-purple-500'
      }
      return 'bg-purple-100'
    },
    handleInput (e, categoryID, fieldID) {
      if (!this.answers[categoryID]) {
        this.$set(this.answers, categoryID, {})
      }
      if (this.categories[categoryID].singleAnswer) {
        this.$set(this.answers, categoryID, {})
      }
      this.$set(this.answers[categoryID], fieldID, !this.answers[categoryID][fieldID])
    },
    openAutoTest () {
      this.$f7router.navigate('/user-auto-test/')
    },
    openQuestionary () {
      this.$f7router.navigate('/user-questionary/')
    },
    handleSelect (personID) {
      if (personID) {
        this.selectedPersonID = personID
      } else {
        this.selectedPersonID = ''
      }
    },
    nextPerson () {
      for (const personID in this.persons) {
        if (!this.alreadyReportedToday[personID]) {
          this.selectedPersonID = personID
          return
        }
      }
      this.handleSelect()
    },
    async callSubmitAnswers () {
      try {
        this.$f7.preloader.show('Enviando información...')
        await axios({
          url: '/campaigns/submitAnswers',
          method: 'POST',
          data: {
            campaignID: this.campaignID,
            userID: this.uid,
            personID: this.selectedPersonID,
            instanceID: this.instanceID,
            answers: this.answers,
          },
        })
        // console.info(response)
        this.nextPerson()
        this.$f7.preloader.hide()
      } catch (err) {
        console.error(err)
        this.$f7.preloader.hide()
        this.$f7.dialog.alert('Ocurrió un error reportando síntomas. Revisa tu conexión a internet.', '¡Ups!')
      }
    },
    async submitAnswers () {
      const lastCategoryID = this.categoryIDs[this.categoryIDs.length - 1]
      if (this.stuckElementID !== lastCategoryID) {
        // if (window.scrollHeight - window.scrollTop !== window.clientHeight) {
        const index = this.categoryIDs.indexOf(this.stuckElementID)
        const categoryID = this.categoryIDs[index + 1]
        const element = this.$refs[categoryID][0]
        const currentPage = document.getElementsByClassName('page-current')[0]
        const content = currentPage.childNodes[0]
        this.stuckElementID = element.id.split('-')[0]
        const y = element.getBoundingClientRect().top + content.scrollTop + 5
        content.scrollTo({
          top: y,
          behavior: 'smooth',
        })
        // element.scrollIntoView({ behavior: 'smooth' })
        return
        // }
      }
      await this.callSubmitAnswers()
    },
  },
}
</script>
<style lang='scss'>
@import '../css/brand';
.chain-counter-footer {
  text-align: center;
  font-size: 18px;
}
.report-card {
  border: solid #51DFB8;
  padding: 10px;
  border-radius: 5px;
  max-width: $width-pc;
  margin: 100px auto $card-margin auto;
  text-align: right;
  position: relative;
}
.report-card > div:first-of-type {
  margin-left: 10px;
}
.report-icon {
  transform: translateY(3px);
  position:absolute;
  top: 5px;
  left: 5px;
}
.report-text {
  padding: 5px;
}
.report-image {
  width: 220px;
  position: absolute;
  opacity: 0.6;
  bottom: 60px;
  left: 15px;
}
.symptom-list {
  max-width: $width-pc;
  margin: $card-margin auto;
}
@media (max-width: 600px) {
  .symptom-list{
    margin: $card-margin;
  }
  .report-card{
    margin: 100px $card-margin $card-margin $card-margin;
  }
}
.symptom-list-item>label>div::after {
  display: none !important;
}
.symptom-list>ul::before {
  display: none !important;
}
.symptom-list>ul::after {
  display: none !important;
}
.form-title {
  width: 200px;
  margin: 20px auto;
  font-weight: bold;
}
.form-text {
  width: 250px;
  margin: 20px auto;
}
.custom-label input:checked + svg {
  opacity: 1 !important;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blinker 2s linear infinite;
}

$track-color: #eceff1 !default;
$thumb-color:  $primary-color !default;

$thumb-radius: 24px !default;
$thumb-height: 48px !default;
$thumb-width: 48px !default;
$thumb-shadow-size: 4px !default;
$thumb-shadow-blur: 4px !default;
$thumb-shadow-color: rgba(0, 0, 0, .2) !default;
$thumb-border-width: 2px !default;
$thumb-border-color: #eceff1 !default;

$track-width: 100% !default;
$track-height: 2px !default;
$track-shadow-size: 1px !default;
$track-shadow-blur: 1px !default;
$track-shadow-color: rgba(0, 0, 0, .2) !default;
$track-border-width: 2px !default;
$track-border-color: #cfd8dc !default;

$track-radius: 5px !default;
$contrast: 5% !default;

@mixin shadow($shadow-size, $shadow-blur, $shadow-color) {
  box-shadow: $shadow-size $shadow-size $shadow-blur $shadow-color, 0 0 $shadow-size lighten($shadow-color, 5%);
}

@mixin track {
  cursor: pointer;
  height: $track-height;
  transition: all .2s ease;
  width: $track-width;
}

@mixin thumb {
  @include shadow($thumb-shadow-size, $thumb-shadow-blur, $thumb-shadow-color);
  background: $thumb-color;
  border: $thumb-border-width solid $thumb-border-color;
  border-radius: $thumb-radius;
  cursor: pointer;
  height: $thumb-height;
  width: $thumb-width;
}

.temp-range {
  -webkit-appearance: none;
  margin: $thumb-height / 2 0;
  width: $track-width;

  &:focus {
    outline: 0;

    &::-webkit-slider-runnable-track {
      background: lighten($track-color, $contrast);
    }

    &::-ms-fill-lower {
      background: $track-color;
    }

    &::-ms-fill-upper {
      background: lighten($track-color, $contrast);
    }
  }

  &::-webkit-slider-runnable-track {
    @include track;
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius;
  }

  &::-webkit-slider-thumb {
    @include thumb;
    -webkit-appearance: none;
    margin-top: ((-$track-border-width * 2 + $track-height) / 2) - ($thumb-height / 2);
  }

  &::-moz-range-track {
    @include track;
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius;
  }

  &::-moz-range-thumb {
    @include thumb;
  }

  &::-ms-track {
    @include track;
    background: transparent;
    border-color: transparent;
    border-width: ($thumb-height / 2) 0;
    color: transparent;
  }

  &::-ms-fill-lower {
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: darken($track-color, $contrast);
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius * 2;
  }

  &::-ms-fill-upper {
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius * 2;
  }

  &::-ms-thumb {
    @include thumb;
    margin-top: 0;
  }
}
.placeholder {
    position: relative;
    display: inline-block;
}

.placeholder::after {
    position: absolute;
    right: 5px;
    top: 16px;
    content: attr(data-placeholder);
    pointer-events: none;
    opacity: 0.6;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
